<template>
	<div>
		<action-sidebar
			title="Editar Template"
			:value="value"
			@close-modal="closeModal"
		>
		<v-layout wrap pa-5>
				<v-flex xs12 mb-3>
					<label>Nombre template
						<v-text-field
							solo
							class="body-1"
							hide-details
							label="Nombre del template"
							required
							v-model="data.name"
							:error="$v.data.name.$error"
						/>
					</label>
				</v-flex>
				<v-flex xs12 mt-5>
					<label>Planes</label>
					<v-select
						solo
						multiple
						box
						chips
						background-color="white"
						class="body-1 mt-2"
						hide-details
						item-text="name"
						item-value="id"
						label="Planes"
						:items="plans"
						v-model="model.plans"
						return-object
					></v-select>
				</v-flex>
				<v-flex xs12 mt-5>
					<label>Integraciones Agregadas</label>
					<v-select
					solo
					multiple
					box
					chips
					hide-details
					:disabled="true"
					class="body-1 mt-2"
					background-color="white"
					item-text="name"
					item-value="id"
					label="Integraciones Agregadas"
					:items="integrations"
					v-model="model.integrations"
					return-object
					></v-select>
				</v-flex>
				<div class="content_add">
					<label class="title">Seleccione las integraciones con una categoría</label>
				</div>
				<v-layout wrap pa-6s v-for="(integration, index) in contIntegrations" :key="index">
					<v-flex xs6 mt-5>
						<label>Integraciones</label>
						<v-select
						solo
						multiple
						box
						chips
						hide-details
						class="body-1 mt-2"
						background-color="white"
						item-text="name"
						item-value="id"
						label="Integraciones"
						:items="integrationsList"
						v-model="model.generalIntegrations[index]"
						return-object
						></v-select>
					</v-flex>
					<v-flex xs6 mt-5>
						<label>Categorías</label>
						<v-select
						solo
						simple
						box
						chips
						hide-details
						class="body-1 mt-2"
						background-color="white"
						item-text="name"
						item-value="id"
						label="Categorías"
						:items="categories"
						v-model="model.generalCategories[index]"
						return-object
						></v-select>
					</v-flex>
					<v-flex xs1 mt-1 v-if="showRemoveButton(index)">
						<v-btn
							class="btn_min"
							color="error"
							@click="removeIntegrationRow(index)"
							>Quitar Selectores
						</v-btn>
					</v-flex>
				</v-layout>
				<div class="content_add">
					<v-btn
						color="primary"
						class="btn_more"
						:disabled="!hasSelections"
						@click="addIntegrationRow"
						>Seleccionar más integraciones
					</v-btn>
				</div>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:is-loading="$v.$invalid"
					:on-run-service="loading"
					@accept-button-clicked="sendData"
					@cancel-button-clicked="closeModal"
				/>
			</section>
		</action-sidebar>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import actionSidebar from '@/components/shared/action-sidebar';

function created() {
	this.editTemplate();
	this.loadPlans();
	this.loadIntegrations();
	this.allIntegrations();
	this.allCategories();
}

async function loadPlans() {
	const url = 'plan/list';
	try {
		const response = await this.$http.get(url);
		this.plans = [...response.data.data];
	} catch (error) {
		this.showError();
	}
}

async function editTemplate() {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const response = await this.$http.get(`template/${this.id}`, { headers });
	this.data = response.data.data;
	this.model.plans = response.data.data.plans;
	this.model.integrations = response.data.data.integrations.integrations;
}

function validations() {
	return {
		data: {
			name: { required },
		},
	};
}

function closeModal() {
	this.loading = true;
	this.goTo('page-template', { params: { projectId: this.projectId } });
	this.loading = false;
}

async function sendData() {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const idsPlan = this.model.plans ? this.model.plans.map(plan => plan.id) : [];
	const idsIntegration = this.model.integrations ?
		this.model.integrations.map(integration => integration.id) : [];
	const body = {
		name: this.data.name,
		description: this.data.description,
		plans: idsPlan,
		integrations: idsIntegration,
	};
	const response = await this.$http.put(`template/${this.id}`, body, { headers });
	const url = 'integrations-template';
	const selectedIntegrations = [];
	this.model.generalIntegrations.forEach((integrations, index) => {
		integrations.forEach((integration) => {
			const category = this.model.generalCategories[index];
			selectedIntegrations.push({
				id: integration.id,
				code: integration.code,
				name: integration.name,
				price: '0',
				categoryId: category.id,
				flagStatus: false,
				flagDefault: true,
				categoryCode: category.code,
				categoryName: category.name,
			});
		});
	});
	const model = {
		integrations:
		selectedIntegrations,
		integrationIds: selectedIntegrations.map(integration => integration.id),
		templateCode: this.codeTemplate,
	};
	await this.$http.patch(url, model);
	this.data = response.data.data;
	this.showNotification('El template fue actualizado correctamente.');
	this.closeModal();
}

async function loadIntegrations() {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	try {
		const response = await this.$http.get(`template/${this.id}`, { headers });
		this.integrations = [...response.data.data.integrations.integrations];
	} catch (error) {
		this.showNotification('El template no tiene integraciones');
	}
}

async function allIntegrations() {
	try {
		const url = 'integrations';
		const dataResponse = await this.$http.get(url);
		this.integrationsList = [...dataResponse.data.data];
	} catch (error) {
		this.showError();
	}
}

async function allCategories() {
	try {
		const url = 'categories';
		const catResponse = await this.$http.get(url);
		this.categories = [...catResponse.data.data];
	} catch (error) {
		this.showError();
	}
}

function addIntegrationRow() {
	const newIndex = this.contIntegrations.length;
	this.$set(this.contIntegrations, newIndex, newIndex);
	this.$set(this.model.generalIntegrations, newIndex, []);
	this.$set(this.model.generalCategories, newIndex, []);
	this.showRemoveButtonFlags[newIndex] = true;
}

function removeIntegrationRow(index) {
	this.contIntegrations.splice(index, 1);
	this.model.generalIntegrations.splice(index, 1);
	this.model.generalCategories.splice(index, 1);
	this.showRemoveButtonFlags.splice(index, 1);
}

function showRemoveButton(index) {
	return this.showRemoveButtonFlags[index];
}

function data() {
	return {
		data: {},
		loading: false,
		value: true,
		add_integration: false,
		model: {
			name: '',
			plans: [],
			integrations: [],
			integrationsList: [],
			categories: [],
			generalIntegrations: [],
			generalCategories: [],
		},
		plans: [],
		integrations: [],
		integrationsList: [],
		categories: [],
		contIntegrations: [0],
		showRemoveButtonFlags: [],
	};
}

export default {
	name: 'page-template-edit-name',
	created,
	components: {
		actionSidebar,
	},
	computed: {
		hasSelections() {
			return this.model.generalIntegrations.length !== 0 &&
				this.model.generalCategories.length !== 0;
		},
	},
	data,
	methods: {
		closeModal,
		editTemplate,
		sendData,
		loadPlans,
		loadIntegrations,
		allIntegrations,
		allCategories,
		addIntegrationRow,
		removeIntegrationRow,
		showRemoveButton,
	},
	props: {
		id: {
			type: [Number, String],
		},
		projectId: {
			type: [Number, String],
		},
		codeTemplate: {
			type: [Number, String],
		},
	},
	validations,
};
</script>
<style scoped>
	.content_add{
		width: 100%;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.title{
		font-size: 15px;
		padding-top: 20px;
		margin-bottom: -20px;
	}
	.btn_more{
		margin-top: 1px;
		border-radius: 5px;
	}
	.btn_min{
		font-size: 14px;
		margin-top: 20%;
		margin-left: 165px;
		cursor: pointer;
		position: relative;
		justify-content: center;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/pages/template/page-template-edit-name.vue